import React from 'react';
import styled from 'styled-components';
import aboutImg from '../../Images/about/aboutimg.jpg';
import { Link } from 'react-router-dom';

const AboutSection = () => {
    return (
        <Container>
            <ContainerText>
                <span>About Us</span>
                <h4>Without Stopping For a Moment We Give You Best Technology Experience</h4>
                <p>We are offering complete IT support & services globally including several web development and web design services to provide all the desired solutions to clients at single platform. Our services are not limited to development and designing of websites but we offer their transformation toward powerful channels of business.  Our Major league expertise is to avail the most hybrid incubation atmosphere for Start-Up’s in BRICS, G20 & ASEAN nations. DemiGod House group with realistic vision to transform entrprises in advance as per futuristic revolution for keeping ourself & our associates /clientele as winners in the markets worldwide.</p>
                <div className="services__button">
                    <Link to="/contactus">Schedule a Call</Link>
                </div>
            </ContainerText>
            <ContainerImage>
                <img src={aboutImg} alt="About" />
            </ContainerImage>
        </Container>

    )
}

export default AboutSection


const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5rem 5rem;
    background: #fff;
    @media screen and (max-width: 900px){
        flex-direction: column;
        padding: 2rem 0.5rem;
    }
`

const ContainerText = styled.div`
    color: #000219;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    padding: 0rem 1rem;
    /* align-items: center; */
    span{
        font-weight: 600;
        display: block;
        margin-bottom: 10px;
        color: #e21f36;
    }
    h4{
        color: #000219;
        font-size: 2rem;
    }
    p{
        color: #000219;
        font-size: 1.1rem;
        line-height: 1.5;
    }
    a {
        text-align: center;
        text-decoration: none;
        padding: 0.8rem 1rem;
        font-size: 1.3rem;
        color: #fff;
        transition: 0.3s ease;
        margin: 1rem 0rem;
        border: none;
        box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.4) inset;
        background: #E21F36;
        &:hover {
        /* opacity: 0.8; */
        background: orangered;
        }
    }
    @media screen and (max-width: 900px){
        span, h4{
            text-align: center;
        }
    }
`;

const ContainerImage = styled.div`
    flex: 1;
    /* padding: 0rem 1rem; */
    img{
        width: 100%;
        height: auto;
        /* object-fit: contain; */
        padding: 2rem;
    }
    @media screen and (max-width: 900px){
        img{
            display: none;
        }
    }
`